import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { SalesOrderItem } from '../state-man/models/sales-order-item.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class SalesOrderItemService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  // version: the one that came with the list already held, or '' for none.
  public async getAll (version: string) : Promise<{ version: string, rows: SalesOrderItem[] | null } | null> {  
    try {
      const ret = await this.apiService.getVersionedList('sales_order_item/', version)
      return ret && { version: ret.version, rows: ret.rows && SalesOrderItem.buildMany(ret.rows) }
    } 
    catch (error) {    
      LoggerService.log(error + 'sales_order_item/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')      
      return null
    }
  }  
}
